<template>
    <div>

        <fieldset>
            <legend>加工尺寸</legend>
            <div class="param-row">
                <label>毛胚宽:</label>
                <NumberInput v-model="blankWidth" style="width:80px" @paste-pair="([x, y]) => { blankWidth = x; width = y; changeSize() }" @change="changeSize" />
                <span class="hint">零件宽:</span>
                <NumberInput v-model="width" style="width:80px" @paste-pair="([x, y]) => { blankWidth = x; width = y; changeSize() }" @change="changeSize" />
            </div>
            <div class="param-row">
                <label>毛胚多余(X单边):</label>
                <span>{{extraX}}</span>
            </div>
            <div class="param-row">
                <label>毛胚高:</label>
                <NumberInput v-model="blankHeight" style="width:80px" @paste-pair="([x, y]) => { blankHeight = x; height = y; changeSize() }" @change="changeSize" />
                <span class="hint">零件高:</span>
                <NumberInput v-model="height" style="width:80px" @paste-pair="([x, y]) => { blankHeight = x; height = y; changeSize() }" @change="changeSize" />
            </div>
            <div class="param-row">
                <label>毛胚多余(Y单边):</label>
                <span>{{extraY}}</span>
            </div>
            <div class="param-row">
                <label>零件深:</label>
                <NumberInput v-model="depth" style="width:80px" />
            </div>
        </fieldset>

        <fieldset>
            <legend>刀具与加工参数</legend>
            <div class="param-row">
                <label>主轴转速:</label>
                <NumberInput v-model="spindleRPM" style="width:100px" />
            </div>
            <div class="param-row">
                <label>进给:</label>
                <NumberInput v-model="feed" style="width:100px" />
            </div>
            <div class="param-row">
                <label>刀具直径:</label>
                <NumberInput v-model="toolDiameter" style="width:100px" />
            </div>
        </fieldset>

        <fieldset>
            <legend>顶面加工参数</legend>
            <div class="param-row">
                <label style="width:auto"><input v-model="bMillTop" type="checkbox"> 启用顶面加工</label>
            </div>
            <div class="param-row">
                <label>顶面预铣深度:</label>
                <NumberInput v-model="premillDepth" style="width:100px" />
            </div>
            <div class="param-row">
                <label>面铣吃刀量(%):</label>
                <NumberInput v-model="millCutting" style="width:80px" />
                <span class="hint">={{ millCuttingActual.toFixed(1) }}mm</span>
            </div>
            <div class="param-row">
                <label>面铣下刀深度:</label>
                <NumberInput v-model="levelDepthFace" style="width:100px" />
            </div>
            <div class="param-row">
                <label>走刀方式:</label>
                <label style="width:auto"><input v-model="topFacePattern" type="radio" value="zigzag"> 往复</label>
                <label style="width:auto"><input v-model="topFacePattern" type="radio" value="spiral"> 回旋</label>
            </div>
        </fieldset>

        <fieldset>
            <legend>侧面加工参数</legend>
            <div class="param-row">
                <label style="width:auto"><input v-model="bMillSide" type="checkbox"> 启用侧面加工</label>
            </div>
            <div class="param-row">
                <label>每层下刀深度:</label>
                <NumberInput v-model="levelDepthSide" style="width:100px" />
            </div>
            <div class="param-row">
                <label>R角半径:</label>
                <NumberInput v-model="cornerRadius" style="width:100px" />
            </div>
            <div class="param-row">
                <label>走刀方式:</label>
                <label style="width:auto"><input v-model="sidePattern" type="radio" value="helical"> 螺旋</label>
                <label style="width:auto"><input v-model="sidePattern" type="radio" value="layer"> 逐层</label>
            </div>
        </fieldset>

        <fieldset>
            <legend>生成</legend>
            <button @click="generateNC">后处理NC文件</button>
        </fieldset>

    </div>
</template>

<script>
/*eslint no-constant-condition: ["error", { "checkLoops": false }]*/

import { ref, inject } from "vue";
import NumberInput from "./NumberInput.vue";

export default {
    components: { NumberInput },
    setup() {
        const fileManager = inject("fileManager");

        return {
            useAlignData: ref(true),

            blankWidth: ref(100),
            blankHeight: ref(60),
            width: ref(98),
            height: ref(58),
            extraX: ref(1),
            extraY: ref(1),

            depth: ref(24),
            premillDepth: ref(0.3),
            remainBottom: ref(0.1),
            remainSide: ref(0.2),
            spindleRPM: ref(12000),
            levelDepthFace: ref(0.2),
            levelDepthSide: ref(0.2),
            feed: ref(2000),
            toolDiameter: ref(8),
            millCutting: ref(60),
            cornerRadius: ref(0),
            safeZ: ref(10),
            bMillTop: ref(true),
            bMillSide: ref(true),
            topFacePattern: ref("spiral"),
            sidePattern: ref("helical"),

            fileManager,
        };
    },

    computed: {
        millCuttingActual() {
            return this.toolDiameter * this.millCutting / 100;
        },
    },

    methods: {
        changeSize() {
            this.extraX = (this.blankWidth - this.width) / 2;
            if (this.extraX < 0) {
                this.extraX = 0;
            }
            this.extraY = (this.blankHeight - this.height) / 2;
            if (this.extraY < 0) {
                this.extraY = 0;
            }
        },

        generateMillFace(w, h, z) {
            let tooR = this.toolDiameter / 2;

            // 实时加工点(右下角)
            let _x = w / 2;
            let _y = -h / 2 + this.millCuttingActual;

            // 右下角起刀
            let x = _x + this.toolDiameter;
            let y = _y - tooR;

            let nc = `
G0 Z${this.safeZ.toFixed(3)}
X${x.toFixed(3)} Y${y.toFixed(3)}
G1 Z${z.toFixed(3)} F${this.feed}
X${_x.toFixed(3)}
`;
            _x = -_x + this.millCuttingActual;

            while (true) {
                // 左
                nc += `X${(_x - tooR).toFixed(3)}\n`;

                // 上
                _y = -_y;
                nc += `Y${(_y + tooR).toFixed(3)}\n`;

                // 右
                _x = -_x;
                nc += `X${(_x + tooR).toFixed(3)}\n`;

                // 工件横放，最后一路是向右走
                if (_y < 0) {
                    break;
                }
                // 最后一路刚好铣完，如果是铝铜等较软的金属，会右毛刺墙残留，多铣一路去残留
                else if (_y == 0) {
                    _y = -this.millCuttingActual / 2;
                } else {
                    _y = -_y + this.millCuttingActual;
                }

                // 下
                nc += `Y${(_y - tooR).toFixed(3)}\n`;

                // 工件竖放，最后一路是向下走
                if (_x < 0) {
                    break;
                }
                // 多铣一路去毛刺残留(同Y方向)
                else if (_x == 0) {
                    _x = -this.millCuttingActual / 2;
                } else {
                    _x = -_x + this.millCuttingActual;
                }
            }

            nc += `G0 Z${this.safeZ.toFixed(3)}\n`;

            return nc;
        },

        // 往复（弓字形）刀路：左右往复走刀，步进方向为Y轴
        generateMillFaceZigzag(w, h, z) {
            let tooR = this.toolDiameter / 2;

            // 刀具中心有效范围（考虑刀具半径，确保刀具覆盖边缘）
            let xMin = -(w / 2) + tooR;
            let xMax = w / 2 - tooR;
            let yBottom = -(h / 2) + tooR;
            let yTop = h / 2 - tooR;

            // 计算Y方向需要走多少刀
            let totalY = yTop - yBottom;
            let passCount = Math.ceil(totalY / this.millCuttingActual);
            if (passCount < 1) passCount = 1;
            let stepY = totalY / passCount;

            // 左下角外侧起刀
            let nc = `
G0 Z${this.safeZ.toFixed(3)}
X${(xMin - this.toolDiameter).toFixed(3)} Y${yBottom.toFixed(3)}
G1 Z${z.toFixed(3)} F${this.feed}
`;

            let currentY = yBottom;

            for (let i = 0; i < passCount; i++) {
                // 向右走
                nc += `X${xMax.toFixed(3)}\n`;

                // Y方向步进
                currentY += stepY;
                if (currentY > yTop) currentY = yTop;
                nc += `Y${currentY.toFixed(3)}\n`;

                i++;
                if (i >= passCount) break;

                // 向左走
                nc += `X${xMin.toFixed(3)}\n`;

                // Y方向步进
                currentY += stepY;
                if (currentY > yTop) currentY = yTop;
                nc += `Y${currentY.toFixed(3)}\n`;
            }

            // 顶部清理走刀（多铣一路去毛刺残留）
            if (passCount % 2 === 0) {
                // 偶数刀：最后向左走，清理向右走
                nc += `X${xMax.toFixed(3)}\n`;
            } else {
                // 奇数刀：最后向右走，清理向左走
                nc += `X${xMin.toFixed(3)}\n`;
            }

            nc += `G0 Z${this.safeZ.toFixed(3)}\n`;

            return nc;
        },

        generateMillSide(w, h, fromZ, toZ) {
            // 带入刀半径，换算成刀中心
            w += this.toolDiameter;
            h += this.toolDiameter;
            let R =
                this.cornerRadius > 0
                    ? this.cornerRadius + this.toolDiameter / 2
                    : 0;

            let x1 = -w / 2,
                y1 = -h / 2; // 左下角
            let x2 = w / 2,
                y2 = h / 2; // 右下角

            let z = fromZ - this.levelDepthSide;
            let nc = `
G0 Z${this.safeZ.toFixed(3)}
G0 X${(x2 + this.toolDiameter).toFixed(3)} Y${y1.toFixed(3)}
`;

            this.levelDepthSide = Math.abs(this.levelDepthSide);
            let levels = Math.ceil(
                Math.abs(toZ - fromZ) / this.levelDepthSide
            );

            for (let l = 0; l < levels; l++) {
                if (z < toZ) {
                    z = toZ;
                }

                // 下刀
                nc += `G1 Z${z.toFixed(3)} F${this.feed}\n`;

                // 左
                nc += `G1 X${(x1 + R).toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${x1.toFixed(3)} Y${(y1 + R).toFixed(3)} R${R.toFixed(3)} I0 J${R.toFixed(3)}\n`;
                }

                // 前
                nc += `G1 Y${(y2 - R).toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${(x1 + R).toFixed(3)} Y${y2.toFixed(3)} R${R.toFixed(3)} I0 J${R.toFixed(3)}\n`;
                }

                // 右
                nc += `G1 X${(x2 - R).toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${x2.toFixed(3)} Y${(y2 - R).toFixed(3)} R${R.toFixed(3)} I0 J${R.toFixed(3)}\n`;
                }

                // 后
                nc += `G1 Y${(y1 + R).toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${(x2 - R).toFixed(3)} Y${y1.toFixed(3)} R${R.toFixed(3)} I0 J${R.toFixed(3)}\n`;
                }

                nc += `G0 Y${(y1 - this.toolDiameter).toFixed(3)}\n`;
                nc += `X${(x2 + this.toolDiameter).toFixed(3)}\n`;
                nc += `Y${y1.toFixed(3)}\n`;

                z -= this.levelDepthSide;
            }

            nc += `G0 Z${this.safeZ.toFixed(3)}\n`;

            return nc;
        },

        // 螺旋走刀：连续螺旋下刀，Z随XY移动同步下降
        generateMillSideHelical(w, h, fromZ, toZ) {
            w += this.toolDiameter;
            h += this.toolDiameter;
            let R = this.cornerRadius > 0
                ? this.cornerRadius + this.toolDiameter / 2
                : 0;

            let x1 = -w / 2, y1 = -h / 2;
            let x2 = w / 2, y2 = h / 2;

            this.levelDepthSide = Math.abs(this.levelDepthSide);
            let totalDepth = Math.abs(toZ - fromZ);
            let levels = Math.ceil(totalDepth / this.levelDepthSide);
            let stepZ = totalDepth / levels;
            let dzPerSide = stepZ / 4;

            let nc = `
G0 Z${this.safeZ.toFixed(3)}
G0 X${(x2 + this.toolDiameter).toFixed(3)} Y${y1.toFixed(3)}
G1 Z${fromZ.toFixed(3)} F${this.feed}
`;

            let z = fromZ;

            for (let l = 0; l < levels; l++) {
                let zEnd = z - stepZ;
                if (zEnd < toZ) zEnd = toZ;

                // 左：沿底边向左走，同时下刀
                z = Math.max(zEnd, z - dzPerSide);
                nc += `G1 X${(x1 + R).toFixed(3)} Z${z.toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${x1.toFixed(3)} Y${(y1 + R).toFixed(3)} R${R.toFixed(3)}\n`;
                }

                // 前：沿左边向上走
                z = Math.max(zEnd, z - dzPerSide);
                nc += `G1 Y${(y2 - R).toFixed(3)} Z${z.toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${(x1 + R).toFixed(3)} Y${y2.toFixed(3)} R${R.toFixed(3)}\n`;
                }

                // 右：沿顶边向右走
                z = Math.max(zEnd, z - dzPerSide);
                nc += `G1 X${(x2 - R).toFixed(3)} Z${z.toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${x2.toFixed(3)} Y${(y2 - R).toFixed(3)} R${R.toFixed(3)}\n`;
                }

                // 后：沿右边向下走
                z = Math.max(zEnd, z - dzPerSide);
                nc += `G1 Y${(y1 + R).toFixed(3)} Z${z.toFixed(3)}\n`;
                if (R) {
                    nc += `G02 X${(x2 - R).toFixed(3)} Y${y1.toFixed(3)} R${R.toFixed(3)}\n`;
                }

                z = zEnd;
            }

            nc += `G0 Z${this.safeZ.toFixed(3)}\n`;

            return nc;
        },

        generateNC() {
            if (this.extraX > this.toolDiameter) {
                alert("毛胚多余(X单边) 不能大于刀具直径");
                return false;
            }
            if (this.extraY > this.toolDiameter) {
                alert("毛胚多余(Y单边) 不能大于刀具直径");
                return false;
            }

            // 生成时间
            const now = new Date();
            const ts = now.getFullYear() + "-"
                + String(now.getMonth() + 1).padStart(2, "0") + "-"
                + String(now.getDate()).padStart(2, "0") + " "
                + String(now.getHours()).padStart(2, "0") + ":"
                + String(now.getMinutes()).padStart(2, "0") + ":"
                + String(now.getSeconds()).padStart(2, "0");

            let nc = `(5面铣  生成时间: ${ts})\n`;
            nc += `(毛胚=${this.blankWidth}×${this.blankHeight}mm  零件=${this.width}×${this.height}×${this.depth}mm  余量X=${this.extraX}mm Y=${this.extraY}mm)\n`;
            nc += `(刀具直径=${this.toolDiameter}mm  主轴=${this.spindleRPM}RPM  进给=${this.feed}mm/min)\n`;
            if (this.bMillTop) {
                const topLabel = this.topFacePattern === "zigzag" ? "往复" : "回旋";
                nc += `(顶面: 预铣深度=${this.premillDepth.toFixed(2)}mm  吃刀量=${this.millCuttingActual.toFixed(1)}mm  下刀=${this.levelDepthFace.toFixed(2)}mm  走刀=${topLabel})\n`;
            } else {
                nc += `(顶面: 未启用)\n`;
            }
            if (this.bMillSide) {
                const sideLabel = this.sidePattern === "helical" ? "螺旋" : "逐层";
                nc += `(侧面: R角=${this.cornerRadius}mm  每层下刀=${this.levelDepthSide.toFixed(2)}mm  走刀=${sideLabel})\n`;
            } else {
                nc += `(侧面: 未启用)\n`;
            }
            nc += `(安全高度=${this.safeZ.toFixed(1)}mm  使用G90绝对坐标)\n`;
            nc += `%\n`;
            nc += `G90 G54\n`;
            nc += `G0 Z${this.safeZ.toFixed(3)} S${this.spindleRPM} M03\n`;
            let wcz = 0;

            // 顶面预铣
            if (this.bMillTop && this.premillDepth > 0 && this.levelDepthFace > 0) {
                const genFace = this.topFacePattern === "zigzag"
                    ? this.generateMillFaceZigzag
                    : this.generateMillFace;

                // 完整步数先行，余数放在最后一层
                let fullSteps = Math.floor(this.premillDepth / this.levelDepthFace);
                let remainder = this.premillDepth - fullSteps * this.levelDepthFace;

                let z = -this.levelDepthFace;
                for (let i = 0; i < fullSteps; i++) {
                    nc += genFace(
                        this.width + this.extraX * 2,
                        this.height + this.extraY * 2,
                        z
                    );
                    z -= this.levelDepthFace;
                }

                // 余数层（或不足一个完整步长只铣一层的情况）
                if (remainder > 0.001 || fullSteps === 0) {
                    nc += genFace(
                        this.width + this.extraX * 2,
                        this.height + this.extraY * 2,
                        -this.premillDepth
                    );
                }

                wcz = -this.premillDepth;
            }

            // 铣四侧面
            if (this.bMillSide) {
                const genSide = this.sidePattern === "helical"
                    ? this.generateMillSideHelical
                    : this.generateMillSide;
                nc += genSide(
                    this.width,
                    this.height,
                    wcz,
                    wcz - this.depth
                );
            }

            const filename = `${this.width}x${this.height}x${this.depth}-R${this.cornerRadius}.nc`;
            this.fileManager.addFileTab(filename, nc);
        },
    },
};
</script>
